import {wymsFetch, getParams} from '@/utils/fetch';

// 删除课程
export function deleteCurriculum(args) {
    const params = getParams();
    params.append('delIds', args.delIds);

    return wymsFetch({
        url: 'curriculum/deleteCurriculum',
        method: 'GET',
        params
    });
}

// 新增课程
export function addCurriculum(args) {
    const params = getParams();
    params.append('examType', args.examType);
    params.append('isMain', args.isMain);
    params.append('level', args.level);
    params.append('logoUrl', args.logoUrl);
    params.append('name', args.name);
    params.append('otherName', args.otherName);
    params.append('code', args.code);
    params.append('isNS', args.isNS);
    params.append('order', args.order);
    return wymsFetch({
        url: 'curriculum/addCurriculum',
        method: 'POST',
        data: params
    });
}

// 查询课程列表
export function queryCurriculumList(args) {
    const params = getParams(true, args);
    params.append('level', args.level);
    params.append('searchName', args.searchName);

    return wymsFetch({
        url: 'curriculum/queryCurriculumList',
        method: 'GET',
        params
    });
}

// 查询课程详情
export function queryCurriculumDetail(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'curriculum/queryCurriculumDetail',
        method: 'GET',
        params
    });
}

// 编辑课程
export function editCurriculum(args) {
    const params = getParams();
    params.append('examType', args.examType);
    params.append('isMain', args.isMain);
    params.append('level', args.level);
    params.append('logoUrl', args.logoUrl);
    params.append('name', args.name);
    params.append('otherName', args.otherName);
    params.append('id', args.id);
    params.append('code', args.code);
    params.append('isNS', args.isNS);
    params.append('order', args.order);
    return wymsFetch({
        url: 'curriculum/editCurriculum',
        method: 'POST',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/subjectManagement.js